import API from 'services/API';

export default function getActiveRelations(params) {
  return API.request({
    method: 'GET',
    url: '/guardianship/viewable',
    params,
  });
}
